import Swiper from 'swiper';
import { refs, domReady } from '../modules/utils.js';
import { matches } from '../modules/media-queries.js';

class SwiperSlider extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#initSlider();
    this.#listeners();
  }

  #listeners() {
    document.addEventListener('swiperslidernav:next', () => {
      this.slider?.slideNext();
    });

    document.addEventListener('swiperslidernav:prev', () => {
      this.slider?.slidePrev();
    });

    document.addEventListener('mediaquery:change', ({ detail }) => {
      if (detail.key === 'small') {
        this.#initSlider();
      }
    });
  }

  #initSlider() {
    const spaceBetween = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--grid-unit'));
    const isSmallViewport = matches('sm');
    const isMediumViewport = matches('md');

    let slidesPerView = 1;
    if (this.dataset.slidesPerView) {
      slidesPerView = parseFloat(this.dataset.slidesPerView);
    }
    if (isSmallViewport && this.dataset.slidesPerViewSm) {
      slidesPerView = parseFloat(this.dataset.slidesPerViewSm);
    }
    if (isMediumViewport && this.dataset.slidesPerViewMd) {
      slidesPerView = parseFloat(this.dataset.slidesPerViewMd);
    }

    this.slider = new Swiper(
      this,
      {
        slidesPerView,
        spaceBetween,
        loop: false
      }
    );
  }
}

customElements.define('swiper-slider', SwiperSlider);
